// @ts-nocheck
// TODO: tighten types after migration
import React, { useState } from 'react';
import './Subscribe.css';
import { API_ENDPOINTS } from '../config/api';

export default function Subscribe() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        // Validate email
        if (!email.trim()) {
            setError('Please enter your email address');
            return;
        }

        if (!validateEmail(email)) {
            setError('Please enter a valid email address');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(API_ENDPOINTS.NEWSLETTER.SUBSCRIBE, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: email.trim() }),
            });

            const data = await response.json();

            if (response.ok) {
                setSuccess(data.message || 'Successfully subscribed!');
                setEmail('');
                // Clear success message after 5 seconds
                setTimeout(() => {
                    setSuccess('');
                }, 5000);
            } else {
                setError(data.message || 'Failed to subscribe. Please try again.');
            }
        } catch (err) {
            console.error('Error subscribing to newsletter:', err);
            setError('Network error. Please check your connection and try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        // Clear error when user starts typing
        if (error) {
            setError('');
        }
        // Clear success message when user starts typing
        if (success) {
            setSuccess('');
        }
    };

    return (
        <div className="subscribe-container w-full rounded-3xl bg-white/90 p-4 shadow-sm backdrop-blur-sm">
            <h3 className="subscribe-text text-base font-semibold text-slate-900">Want to receive updates? Subscribe now!</h3>
            <form className="subscribe-form mt-3" onSubmit={handleSubmit}>
                <div className={`subscribe-input-wrapper ${error ? 'subscribe-input-error' : ''} ${success ? 'subscribe-input-success' : ''} relative flex items-center overflow-hidden rounded-full bg-slate-100`}>
                    <input
                        type="email"
                        className="subscribe-input w-full bg-transparent text-sm text-slate-800"
                        placeholder="Your email"
                        value={email}
                        onChange={handleEmailChange}
                        disabled={loading}
                    />
                    <button
                        type="submit"
                        className={`subscribe-button ${loading ? 'subscribe-button-loading' : ''} inline-flex h-10 w-10 items-center justify-center rounded-full`}
                        disabled={loading || !email.trim()}
                        aria-label={loading ? 'Subscribing...' : 'Subscribe'}
                    >
                        {loading ? (
                            <span className="subscribe-spinner"></span>
                        ) : (
                            <i className="fi fi-bs-paper-plane"></i>
                        )}
                    </button>
                </div>
                {error && (
                    <div className="subscribe-message subscribe-error">
                        {error}
                    </div>
                )}
                {success && (
                    <div className="subscribe-message subscribe-success">
                        {success}
                    </div>
                )}
            </form>
        </div>
    );
}

